import React from "react";

const CopperForm = ({ formId }) => {
  if (!formId) return null;

  return (
    <iframe
      src={`https://forms.copper.com/j/${formId}?type=embed`}
      width="100%"
      height="680"
      style={{ border: "none" }}
      title="Copper Form"
      id={formId}
    />
  );
};

export default CopperForm;

